// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fake-login-box[data-v-5d597172] {\n  height: 75vh;\n}\n.fake-login-img[data-v-5d597172] {\n  margin-top: 150px;\n}", ""]);
// Exports
module.exports = exports;
